import { financeAPI } from "../../axios"
export const actions = {

    /** Billing */

    createNewBilling(context, data){
        return financeAPI.post("Billing", data)
    },
    updateBilling(context, {billingId, data}){
        return financeAPI.put(`Billing/${billingId}`, data)
    },
    getSingleBilling(context, billingId){
        return financeAPI.get(`Billing/${billingId}`)
    },
    deleteBilling(context, billingId){
        return financeAPI.delete(`Billing/${billingId}`)
    },
    getPendingBillings(context, campusId){
        return financeAPI.get(`Billing/Pending/${campusId}`)
    },
    getPostedBillings(context, campusId){
        return financeAPI.get(`Billing/Posted/${campusId}`)
    },
    postBilling(context, billingId){
        return financeAPI.put(`Billing/Post/${billingId}`)
    },
    postMultipleBilling(context, ids){
        return financeAPI.post(`Billing/Post/Multiple`, ids);
    },
    markAsPaid(context, data){
        return financeAPI.put(`Billing/Paid/${data.id}`, data)
    },
    getUnpaidBillings(context, campusId){
        return financeAPI.get(`Billing/Unpaid/${campusId}`)
    },
    getBillingByReference(context, reference){
        return financeAPI.post(`Billing/Reference`, reference)
    },

    /** Billing Details */

    addNewBillingDetail(context, data){
        return financeAPI.post("BillingDetail/Add", data)
    },
    getBillingDetails(context, billingId){
        return financeAPI.get(`BillingDetail/${billingId}`)
    },
    updateBillingDetail(context, {billingDetail, billindDetailId}){
        return financeAPI.put(`BillingDetail/${billindDetailId}`, billingDetail)
    },
    deleteBillingDetail(context, billingDetailId){
        return financeAPI.delete(`BillingDetail/${billingDetailId}`)
    },


}